import { GracePeriod } from '../interfaces/protheus/GracePeriod';

export const convertGracePeriodProtheusToGracePeriod = (
  gracePeriod: any
): GracePeriod => ({
  code: gracePeriod.ZZ_CODIGO,
  type: gracePeriod.ZZ_DESCCAR,
});
